export default __webpack_public_path__ + "static/media/calendar.08862d96.svg";